import React, { useState, useRef, useEffect } from "react";
import ChevronRightIcon from "../assets/icons/circle-chevron-right.svg";
import ChevronDownIcon from "../assets/icons/circle-chevron-down.svg";
import "../styles/components/vacancy_card.css";

const VacancyCard = ({ title, responsibilities, requirements }) => {
  const [isOpen, setIsOpen] = useState(false);
  const bodyRef = useRef(null);

  useEffect(() => {
    const handleResize = () => {
      if (isOpen && bodyRef.current) {
        bodyRef.current.style.maxHeight = bodyRef.current.scrollHeight + "px";
      }
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [isOpen]);

  const toggleCard = () => {
    if (!bodyRef.current) return;

    if (!isOpen) {
      bodyRef.current.style.maxHeight = bodyRef.current.scrollHeight + "px";
      setIsOpen(true);
    } else {
      bodyRef.current.style.maxHeight = "0px";
      setIsOpen(false);
    }
  };

  return (
    <div className="vacancy-card">
      <div className="vacancy-card-header">
        <div className="vacancy-card-title">{title}</div>
        <button className="vacancy-toggle-btn" onClick={toggleCard}>
          <img
            src={isOpen ? ChevronDownIcon : ChevronRightIcon}
            alt="toggle"
          />
        </button>
      </div>
      <div className="vacancy-card-body" ref={bodyRef}>
        <h3 className="vacancy-card-section-title">Ваши обязанности:</h3>
        <p className="vacancy-card-text">{responsibilities}</p>

        <h3 className="vacancy-card-section-title">Важные требования:</h3>
        <ul className="vacancy-card-list">
          {requirements.map((requirement, index) => (
            <li key={index} className="vacancy-card-list-item">
              {requirement}
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default VacancyCard;
